module.exports = __webpack_public_path__ + "img/tournament-bg_1920.64495c40.png";